import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { createRecipeStyles } from "./styles";
import { FetchedRecipe } from "../../types/recipe";

/**
 * Props for RecipeHeader component.
 * @property {FetchedRecipe} recipe - The recipe object to display header info for.
 */
interface RecipeHeaderProps {
  recipe: FetchedRecipe;
}

/**
 * RecipeHeader Component
 *
 * Displays the main header for a recipe, including reference ID and recipe name.
 * Uses Material UI Paper for styling and layout.
 *
 * @param {RecipeHeaderProps} props - Component props
 * @returns {JSX.Element} The rendered recipe header section
 */
const RecipeHeader: React.FC<RecipeHeaderProps> = ({ recipe }) => {
  const theme = useTheme();
  const styles = createRecipeStyles(theme);

  return (
    <Paper elevation={0} sx={{ ...styles.page.mainCard, borderRadius: 0 }}>
      {/* Main header container */}
      <Box sx={styles.page.mainHeader}>
        <Box sx={styles.page.headerInfo}>
          {/* Reference ID */}
          <Typography variant="body2" sx={styles.page.refText}>
            Ref: {recipe._id || "N/A"}
          </Typography>
          {/* Recipe name/title */}
          <Typography variant="h4" component="h1" sx={styles.page.title}>
            {recipe.data.name || "Untitled Recipe"}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default RecipeHeader;
